import React from 'react'
import BoardMeetings from '../../../components/AnnouncementCorporate/BoardMeetings'

function BoardMeetingsPage() {
    return (
        <div className='mb-6'>
            <BoardMeetings />
        </div>
    )
}

export default BoardMeetingsPage